import AppLoading from "@/components/AppLoading";
import AppError from "@/components/AppError";

const ComponentFactory = (path) => {
  return () => ({
    component: import(
      /* webpackChunkName: "modules" */
      /* webpackPrefetch: true */
      /* webpackPreload: true */
      `@/${path}`
    ),
    loading: AppLoading,
    error: AppError,
    delay: 100,
    timeout: 30000,
  });
};

export const StepMultiReverse = ComponentFactory(
  "components/Multi/StepReverse"
);
export const StepMultiNormal = ComponentFactory("components/Multi/StepNormal");
export const StepSingleReverse = ComponentFactory(
  "components/Single/StepReverse"
);
export const StepSingleNormal = ComponentFactory(
  "components/Single/StepNormal"
);
export const StepComplete = ComponentFactory("components/StepComplete");
